import { render, staticRenderFns } from "./LayoutWrapper.vue?vue&type=template&id=6ae7a2ec&"
import script from "./LayoutWrapper.vue?vue&type=script&lang=js&"
export * from "./LayoutWrapper.vue?vue&type=script&lang=js&"
import style0 from "./LayoutWrapper.vue?vue&type=style&index=0&id=6ae7a2ec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports